import { loadedAsyncState, loadingAsyncState } from "widgets-for-react";
import { fetchSearchResults } from "./searchPageApi";
export const emptySearchResult = {
    results: [],
    totalResults: 0,
    query: "",
    page: 1
};
const initialSearchQuery = ()=>{
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get("query") ? decodeURIComponent(searchParams.get("query")) : "";
};
export const initialState = {
    pageSize: 5,
    searchQuery: initialSearchQuery(),
    searchResults: initialSearchQuery() ? loadingAsyncState(fetchSearchResults(initialSearchQuery(), 1, 5)) : loadedAsyncState(emptySearchResult),
    currentPage: 1
};
export const searchResultsRoute = '/zoeken';
